import clsx from "clsx";
import { HTMLProps } from "react";

const CheckIcon: React.FC<HTMLProps<HTMLElement>> = (
  props: HTMLProps<HTMLElement>
) => (
  <div className={clsx(props.className)}>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.2" cx="8" cy="8" r="8" fill="white" />
      <path
        d="M10.9697 4.96999C11.1105 4.83588 11.298 4.76173 11.4925 4.76321C11.687 4.76468 11.8733 4.84165 12.0121 4.97787C12.1509 5.1141 12.2314 5.29893 12.2366 5.49336C12.2417 5.68779 12.1711 5.87661 12.0397 6.01999L8.04967 11.01C7.98106 11.0839 7.89825 11.1432 7.8062 11.1844C7.71415 11.2255 7.61474 11.2477 7.51392 11.2496C7.4131 11.2514 7.31294 11.2329 7.21943 11.1952C7.12591 11.1575 7.04097 11.1013 6.96967 11.03L4.32367 8.38399C4.24998 8.31532 4.19088 8.23252 4.14989 8.14052C4.1089 8.04853 4.08685 7.94921 4.08508 7.84851C4.0833 7.74781 4.10183 7.64778 4.13955 7.55439C4.17727 7.461 4.23341 7.37617 4.30463 7.30495C4.37585 7.23373 4.46068 7.17758 4.55407 7.13986C4.64746 7.10214 4.74749 7.08362 4.84819 7.08539C4.94889 7.08717 5.04821 7.10921 5.14021 7.15021C5.23221 7.1912 5.31501 7.2503 5.38367 7.32399L7.47767 9.41699L10.9507 4.99199C10.9569 4.98429 10.9636 4.97694 10.9707 4.96999H10.9697Z"
        fill="white"
      />
    </svg>
  </div>
);

export default CheckIcon;
